import "src/css/widgets/widgets.css";

import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone, } from '@fortawesome/fontawesome-svg-core/import.macro';
import React, { useState, useEffect } from 'react';
import MonitorWSService from 'src/services/monitorwsservice';
import { ProgressBar, Row, Col } from "react-bootstrap";
import WidgetSettings from "../widgetSettings";
import { selectionTypes } from "src/components/utils/consts";
import WidgetTools from "../widgetTools";

function AnalysisByCategory(props) {

    const { t } = useTranslation();
    const [selectedGroups, setSelectedGroups] = useState([]);
    const [showSettings, setShowSettings] = useState(false);
    const [channel, setChannel] = useState(localStorage.getItem(`AnalysisByCategory_channel_${props.identifier}_user${props.id}`) || "");
    const [channelName, setChannelName] = useState(localStorage.getItem(`AnalysisByCategory_channelName_${props.identifier}_user${props.id}`) || "");
    const [category, setCategory] = useState([]);

    useEffect(() => {
        // component mounts
        return () => {
            // component unmounts
            if (MonitorWSService?.stompClient?.connected) {
                MonitorWSService.stompClient.send("/app/unsubscribe/analysisbycategory", {}, JSON.stringify({
                    token: props.token,
                }));
                MonitorWSService.stompClient.unsubscribe("analysisbycategory");
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (props.connected) {

            let selectedGroups = JSON.parse(localStorage.getItem(`AnalysisByCategory_groups_${props.identifier}_user${props.id}`) || "[]");
            let channel = localStorage.getItem(`AnalysisByCategory_channel_${props.identifier}_user${props.id}`) || "";
            setSelectedGroups(selectedGroups);

            MonitorWSService.stompClient.subscribe(`/user/${props.token}/topic/analysisbycategory/`, function (callsbygroup) {
                if (localStorage.getItem("resizing") !== "true") {
                    let data = JSON.parse(callsbygroup.body);
                    setCategory(data);
                }
            }, { id: "analysisbycategory" });

            MonitorWSService.stompClient.send("/app/subscribe/analysisbycategory", {}, JSON.stringify({
                token: props.token,
                groupsIds: selectedGroups,
                channel: channel
            }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.connected]);

    const toggleSettings = () => {
        setShowSettings(!showSettings);
    };

    const closeWidget = (e) => {
        e.preventDefault();
        props.close(props.identifier);
    }


    const setGroupsAndChannel = (groups, channel, channelName) => {
        setShowSettings(!showSettings);
        setSelectedGroups(groups);
        localStorage.setItem(`AnalysisByCategory_groups_${props.identifier}_user${props.id}`, JSON.stringify(groups));

        setChannel(channel);
        setChannelName(channelName);
        localStorage.setItem(`AnalysisByCategory_channel_${props.identifier}_user${props.id}`, channel);
        localStorage.setItem(`AnalysisByCategory_channelName_${props.identifier}_user${props.id}`, channelName);

        MonitorWSService.stompClient.send("/app/subscribe/analysisbycategory", {}, JSON.stringify({
            token: props.token,
            groupsIds: groups,
            channel: channel
        }));

    };


    return (

        <div className="card card-flush overflow-hidden h-lg-20 widget-container">
            <div className="card-header">
                <h3 className="card-title align-items-start flex-column text-primary drag-handle">
                    <span className="card-label fw-bold text-primary"><FontAwesomeIcon icon={duotone("bookmark")} /> {t("analysisbycategory")}</span>
                </h3>
                <div className="card-toolbar" style={{ zIndex: 9999 }}>
                    <WidgetTools  key={`tools_${props.identifier}`}closeWidget={closeWidget} toggleSettings={toggleSettings}></WidgetTools>
                </div>
            </div>
            <div className="card-body" style={{ "padding": "0rem 2.25rem", height: "80%", overflow: "auto" }}>
                {
                    category.map((c, i) => {
                        return <Row key={`cat_${i}`}>
                            <Col lg={4} >
                                <span style={{ lineHeight: "45px" }} className="fs-3 text-gray-800 fw-semibold mb-7">{t(c.category)}</span>
                            </Col>
                            <Col lg={6}>
                                <ProgressBar style={{ marginTop: "15px" }}>
                                    <ProgressBar variant="danger" now={c.negativePercent} key={1} />
                                    <ProgressBar variant="gray-800" now={c.neutralPercent} key={2} />
                                    <ProgressBar variant="success" now={c.positivePercent} key={3} />
                                </ProgressBar>
                            </Col>
                            <Col lg={2}>
                                <span style={{ lineHeight: "45px" }} className="card-label fw-bold text-gray-800">
                                    {
                                        c.positivePercent > c.negativePercent && c.positivePercent > c.neutralPercent &&
                                        <span className="text-success" ><FontAwesomeIcon icon={duotone("face-smile")} /> {Math.round(c.positivePercent)}%</span>
                                    }
                                    {
                                        c.neutralPercent > c.positivePercent && c.neutralPercent > c.negativePercent &&
                                        <span className="text-gray-800" ><FontAwesomeIcon icon={duotone("face-meh")} /> {Math.round(c.neutralPercent)}%</span>
                                    }
                                    {
                                        c.negativePercent > c.positivePercent && c.negativePercent > c.neutralPercent &&
                                        <span className="text-angry" ><FontAwesomeIcon icon={duotone("face-angry")} /> {Math.round(c.negativePercent)}%</span>
                                    }
                                </span>
                            </Col>
                        </Row>
                    })
                }
            </div>
            <WidgetSettings key={`settings_${props.identifier}`}showSettings={showSettings} toggleSettings={toggleSettings} token={props.token} setGroupsAndChannel={setGroupsAndChannel} groups={selectedGroups} selectionType={selectionTypes.MESSAGESQUEUE} channel={channel} channelName={channelName}></WidgetSettings>
        </div>

    )
}

const mapStateToProps = (state) => {
    return {
        token: state.supervisor.token,
        connected: state.parameters.connected,
        id: state.supervisor.id,
        rtl: state.parameters.rtl
    };
};

export default connect(mapStateToProps, {})(AnalysisByCategory);